var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin":"20px"},attrs:{"id":"landing"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.getLabelValue('EBIENNIAL_EMAILUPDATE_APPROVED'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }